import React from 'react'
import { string } from 'prop-types'

import { FEATURED_APP_CATEGORIES } from '@/constants'
import { isHelpDesk, isLiveChat } from '@/utils'

import { Divider } from '@/components/Divider'
import Categories from './Categories'
import FeaturedCategories from './FeaturedCategories'
import ProductsSuites from './ProductSuites'
import SidebarWrapper from './SidebarWrapper'
import ProductsHeading from './ProductsHeading'

const Sidebar = ({ className }) => {
  return (
    <SidebarWrapper className={className}>
      {isLiveChat && (
        <>
          <ProductsHeading />
          <ProductsSuites />
        </>
      )}

      <h3>Categories</h3>

      {!isHelpDesk && (
        <>
          <FeaturedCategories categories={FEATURED_APP_CATEGORIES} />
          <Divider />
        </>
      )}
      <Categories isOpenOnInit={isHelpDesk} />
    </SidebarWrapper>
  )
}

Sidebar.propTypes = {
  className: string,
}

export default Sidebar
